import { Component, OnInit } from '@angular/core';
import { DataService } from '../service/data.service';
import { BaseComponent } from '../base.component';
import { ActivatedRoute } from '@angular/router';
import { WindowRef } from '../windowref';
import { MatDialog } from '@angular/material/dialog';
import { ImportFormComponent } from '../import-form/import-form.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent extends BaseComponent implements OnInit {

  formId:string;

  constructor(data:DataService, private importDialog:MatDialog, private activatedRoute: ActivatedRoute, private winRef: WindowRef) {
    super(data);
  }

  ngOnInit() {
    
  }

  onPreview(){
   //this.data.editor.DynamicFormLayoutModel.HttpAlias
   let url = "/"+this.data.editor.DynamicFormLayoutModel.RootUrl+this.data.editor.Routes[0].Url;
    this.winRef.nativeWindow.open(url, '_blank');
  }

  onSave(){
    this.data.save();
  }

  onImport(){
    this.importDialog.open(ImportFormComponent, {
      width: '80%',
      height:'60%'
    });
  }

  onExport(){
    this.data.save();

          // Pretvaranje modela u JSON string
      const jsonData = JSON.stringify(this.data.editor, null, 2);

      // Kreiranje datoteke
      const blob = new Blob([jsonData], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);

        // Dobijanje trenutnog datuma i vremena u formatu ddMMyyyyHHmmss
      const now = new Date();
      const timestamp = now.toLocaleDateString('en-GB').replace(/\//g, '') +
                        now.getHours().toString().padStart(2, '0') +
                        now.getMinutes().toString().padStart(2, '0') +
                        now.getSeconds().toString().padStart(2, '0');

      // Kreiranje naziva datoteke sa trenutnim datumom i vremenom
      const filename = `${this.data.editor.Name}_${timestamp}.json`;

      // Kreiranje linka za preuzimanje
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();

      // Oslobađanje resursa
      window.URL.revokeObjectURL(url);
    // this.data.dataGET(this.data.wsBase+"dynamicforms/view/byname/getformdata/"+this.data.editor.Name.split("-")[1]).subscribe(
    //   data => 
    //   {
    //     /*const blob = new Blob([data["Content"]], {type: "application/vnd.ms-excel;charset=utf-8"});
    //     saveAs(blob, data["FileName"]);*/


    //     var universalBOM = "\uFEFF";
    //     var a = window.document.createElement('a');
    //     //a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
    //     a.setAttribute('download', 'example.csv');
    //     window.document.body.appendChild(a);
    //     a.click();



    //     var universalBOM = "\uFEFF";
    //     const linkSource = 'data:' + data['MimeType'] + ';base64,' + universalBOM + data['Content'];
    //     const downloadLink = document.createElement('a');
    //     document.body.appendChild(downloadLink);
    //     downloadLink.href = linkSource;
    //     downloadLink.target = '_self';
    //     downloadLink.download = data["FileName"];
    //     downloadLink.click();

    //   }
    // );
  }
}
